'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: block;\n  font-size: 32px !important;\n  margin-right: 10px;\n  color: ', ';\n'], ['\n  display: block;\n  font-size: 32px !important;\n  margin-right: 10px;\n  color: ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../../../libs/colors');

var _Icon = require('../../Icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Styles
// Components


var StyledIcon = (0, _styledComponents2.default)(_Icon2.default)(_templateObject, function (_ref) {
  var color = _ref.color;
  return color;
});

var StepsIcon = function StepsIcon(_ref2) {
  var icon = _ref2.icon,
      done = _ref2.done,
      selected = _ref2.selected;
  return _react2.default.createElement(StyledIcon, {
    icon: icon,
    color: selected ? _colors.red : done ? _colors.black : _colors.darkGrey
  });
};

StepsIcon.propTypes = {
  icon: _propTypes2.default.string,
  done: _propTypes2.default.bool,
  selected: _propTypes2.default.bool
};
exports.default = StepsIcon;